module.exports = __webpack_public_path__ + "img/envMonitor.3d3d7242.png";